import React from 'react';

import { Container } from '@components/Container';
import { Layout } from '@components/Layout';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: '【重要】料金改定のお知らせ',
    content: () => (
      <>
        <p>
          【ご案内】
          <br />
          平素よりD2Dサービスをご利用いただき、誠にありがとうございます。
          <br />
          この度運営コストの増加にともない、弊サービスの料金を改定させていただくことになりました。
          <br />
          <br />
          今後も皆様のご愛顧にお応えすべくサービスの向上に努めて参りますので、
          <br />
          何卒、ご理解とご協力の程よろしくお願い申し上げます。
          <br />
          尚、本件に関しご不明な点がございましたら、弊社営業担当までお問い合せ下さい。
          <br />
          <br />
        </p>

        <p style={{ textAlign: 'center' }}>記</p>

        <p>改定後の料金：　8円/KGS up</p>
        <p>新料金開始日：　2022年12月1日（木）</p>

        <p style={{ textAlign: 'end' }}>以上</p>
      </>
    ),
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  title: {
    ...common.normalText,
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '42px',
    marginBottom: '6rem',
  },
  content: {
    ...common.normalText,
    ...common.textGray700,
    marginBottom: 200,
  },
}));

export const PriceUp = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout title={strings.title}>
      <Container>
        <div className={classes.title}>
          {strings.title}
          <br />
          <span className={classes.normalText}>2022.11.17</span>
        </div>
        <div className={classes.content}>{strings.content()}</div>
      </Container>
    </Layout>
  );
};
